export const styles = {
  modal: {
    maxWidth: "520px",
    padding: "24px 16px",
    borderRadius: "16px",
  },

  closeButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    padding: 0,
    zIndex: 2,
    color: "#393939",

    ":hover": {
      border: "none",
    },
  },
};
